module.exports = __webpack_public_path__ + "img/Pick-up-min.225ba54c.png";